// permissionSlice.ts
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  fetchPermissions,
  fetchPermissionsById,
  submitPermissions,
} from "./thunk";

interface PermissionState {
  modules: any[];
  selected: {
    [appName: string]: {
      [moduleName: string]: {
        [action: string]: boolean;
      };
    };
  };
  loading: boolean;
  error: string | null;
}

const initialState: PermissionState = {
  modules: [],
  selected: {},
  loading: false,
  error: null,
};


const permissionSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {
    setPermission(state, action) {
      const { app, module, actionName, checked } = action.payload;
      state.selected[app] = state.selected[app] || {};
      state.selected[app][module] = state.selected[app][module] || {};
      state.selected[app][module][actionName] = checked;
    },
    toggleAllModuleActions(state, action) {
      const { app, module, actions, checked } = action.payload;
      state.selected[app] = state.selected[app] || {};
      state.selected[app][module] = {};
      actions.forEach((act: string) => {
        state.selected[app][module][act] = checked;
      });
    },
    toggleAllAppPermissions(state, action) {
      const { app, modules, checked } = action.payload;
      state.selected[app] = {};
      modules.forEach((mod: any) => {
        state.selected[app][mod.module_name] = {};
        mod.actions.forEach((act: string) => {
          state.selected[app][mod.module_name][act] = checked;
        });
      });
    },
    toggleAllPermissions(state, action) {
      const { allModules, checked } = action.payload;
      state.selected = {};
      allModules.forEach(
        (app: { app_name: string | number; modules: any[] }) => {
          state.selected[app.app_name] = {};
          app.modules.forEach((mod: any) => {
            state.selected[app.app_name][mod.module_name] = {};
            mod.actions.forEach((act: string) => {
              state.selected[app.app_name][mod.module_name][act] = checked;
            });
          });
        }
      );
    },
    setSelectedPermissions(state, action) {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(fetchPermissions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPermissions.fulfilled, (state, action) => {
        state.loading = false;
        state.modules = action.payload;
      })
      .addCase(fetchPermissions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchPermissionsById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPermissionsById.fulfilled, (state, action) => {
        state.loading = false;
        //state.modules = action.payload;
      })
      .addCase(fetchPermissionsById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(submitPermissions.pending, (state) => {
        state.loading = true;
      })
      .addCase(submitPermissions.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(submitPermissions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const {
  setPermission,
  toggleAllModuleActions,
  toggleAllAppPermissions,
  toggleAllPermissions,
  setSelectedPermissions,
} = permissionSlice.actions;

export default permissionSlice.reducer;
